const R = globalThis.React;
const _h = (type, props, key) => {
  const p = props || {};
  const {children, ...rest} = p;
  if (key !== undefined) rest.key = key;
  const kids = children === undefined ? [] : (Array.isArray(children) ? children : [children]);
  return R.createElement(type, rest, ...kids);
};
export const jsx = R.jsx || _h;
export const jsxs = R.jsxs || _h;
export const Fragment = R.Fragment;
export default R;